import { useMedia } from 'react-use'

export function useIsVerySmallDevice() {
  // Should cover resolution for large phones like iPhone Pro Max
  return useMedia('(max-width: 400px)')
}
